import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';

import FetchModule from '../../../../Share/Network/FetchModule';
import moment from 'moment';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function MembershipSubscriptionCancelModal(props) {
  const { memberName, data, index, className, onClickClose, rendering } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [membershipName, setMembershipName] = useState('');
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [totalPrice, setTotalPrice] = useState(0);

  const history = useHistory();

  useEffect(() => {
    document.body.style= `overflow: hidden`;
    return () => document.body.style = `overflow: auto`
  }, [])

  useEffect(() => {
    if (index === -1) return;

    setMembershipName(data[index].memberShipName);
    setStartDate(moment(data[index].startDate));
    setEndDate(moment(data[index].endDate));
    setTotalPrice(data[index].totalPrice.toLocaleString('ko-KR'));
  }, [data, index])

  function onClickCancel() {
    let requestData = {
      merchantUid: data[index].merchantUid
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/cancel/subscribe/', 'POST', requestData);

        if (responseData.status === 200) {
          alert(t('memberDetail.subCancelModal.alertSubCancelled'));
          onClickClose(className);
          rendering();
        }
        else if (responseData.status === 401) {
          alert(t('memberDetail.alertLoginRetry'));
          history.push('/');
        }
        else {
          alert(responseData.error);
          return;
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <ModalView $isDark={isDark}>
        <TotalWrapper>
          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{memberName + t('memberDetail.subCancelModal.subCancelTitle')}</Text>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelDesc')}</Text>
          <MembershipInfoWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={130}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelMembershipName')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={212}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{membershipName}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={130}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelPeriod')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={212}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{startDate.format('YYYY.MM.DD') + ' ~ ' + endDate.format('YYYY.MM.DD')}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={130}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelNextPayDate')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={212}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{endDate.format('YYYY.MM.DD')}</Text>
              </MembershipTextWrapper>
            </LayerWrapper>
            <LayerWrapper>
              <MembershipTextWrapper width={130}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelPayAmount')}</Text>
              </MembershipTextWrapper>
              <MembershipTextWrapper width={212} style={{ gap: '4px' }}>
                <LinkoPayBox>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('memberDetail.subCancelModal.subCancelLinkoPay')}</Text>
                </LinkoPayBox>
                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{totalPrice}</Text>
              </MembershipTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.subCancelModal.subCancelWon')}</Text>
            </LayerWrapper>
          </MembershipInfoWrapper>
          <DivisionLine />
          <ExplanationWrapper>
            <LayerWrapper style={{ flexWrap: 'wrap', rowGap: '0', width: '100%', justifyContent: 'flex-end' }}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning1')}</Text>
              <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.pointRed} cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning2')}</Text>
            </LayerWrapper>
            <Text style={{ width: '100%' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.subCancelModal.subCancelWarning3')}</Text>
          </ExplanationWrapper>
          <ButtonWrapper>
            <ExitButton onClick={onClickClose}>{t('memberDetail.modalCancel')}</ExitButton>
            <SubscriptionCancelButton onClick={onClickCancel}>{t('memberDetail.subCancelModal.subCancelBtn')}</SubscriptionCancelButton>
          </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  justify-content: center;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.2);

	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 20px;

  box-sizing: border-box;
  width: 425px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 385px;
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 30px;

  width: 100%;

  gap: 25px;
`;

const DivisionLine = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin: 15px 0 15px 0;

  width: 100%;
  height: 1px;

  background-color: ${props => props.theme.line};
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const MembershipTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 21px;

  overflow: hidden;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 14px;

  width: 100%;

  text-align: right;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 70px;

  gap: 14px;

  width: 100%;
`;

const LinkoPayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0px 5px;

  border-radius: 5px;
  background-color: ${props => props.theme.subKey};
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SubscriptionCancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 0 10px;

  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
